import i18n from "../../i18n";

export default function SET_USER(state, payload) {
  if (payload) {
    if (payload.displayName !== undefined) {
      state.user.displayName = payload.displayName;
    }
    if (payload.photoURL !== undefined) {
      state.user.photoURL = payload.photoURL;
    }
    if (payload.email !== undefined) {
      state.user.email = payload.email;
    }
    if (payload.emailVerified !== undefined) {
      state.user.emailVerified = payload.emailVerified;
    }
    if (payload.uid !== undefined) {
      state.user.uid = payload.uid;
    }
    if (payload.title !== undefined) {
      state.user.title = payload.title;
    }
    if (payload.admin !== undefined) {
      state.user.admin = payload.admin;
    }
    if (
      payload.language !== undefined &&
      payload.language !== null &&
      payload.language !== state.user.language
    ) {
      state.user.language = payload.language;
      i18n.global.locale = payload.language;
    }
  } else {
    state.user = {
      uid: null,
      email: null,
      displayName: null,
      title: null,
      photoURL: null,
      admin: false,
      emailVerified: false,
      language: null,
    };
  }
}
